export enum EIndicadorPresenca {
  NaoSeAplica = 0,
  OperacaoPresencial = 1,
  OperacaoInternet = 2,
  OperacaoTeleatendimento = 3,
  OperacaoEntregaDomicilio = 4,
  OperacaoForaEstabelecimento = 5,
  OperacaoNaoPresencial = 6,
}
